export default "__VITE_ASSET__D_Ah25R8__"